import { CardContainer, TitleContainer, TextContainer } from "./Card.styles";
const Card = () => {
  return (
    <CardContainer>
      <TitleContainer>Keep moving up</TitleContainer>
      <TextContainer>
      Learn the skills you need to take the next step — and every step after. Log in now to save on courses through July 27.
      </TextContainer>
    </CardContainer>
  );
};

export default Card;
